export function truncateKMLDisplay(kml: string | Document) {
  const kmlDoc = typeof kml === "string" ? new DOMParser().parseFromString(kml, "text/xml") : kml;
  const truncatedKmlDoc = kmlDoc.cloneNode(true) as Document;
  const coordinateElements = truncatedKmlDoc.getElementsByTagName("coordinates");
  for (let i = 0; i < coordinateElements.length; i++) {
    coordinateElements[i].textContent = "[ ... ]";
  }

  // Handle LinearRing/Point/LineString that might use <coord> or individual <X><Y><Z> elements
  const geometryElements = [
    ...Array.from(truncatedKmlDoc.getElementsByTagName("Point")),
    ...Array.from(truncatedKmlDoc.getElementsByTagName("LineString")),
    ...Array.from(truncatedKmlDoc.getElementsByTagName("LinearRing")),
    ...Array.from(truncatedKmlDoc.getElementsByTagName("Polygon")),
  ];
  geometryElements.forEach((element) => {
    // Handle individual coordinate components
    ["coord", "X", "Y", "Z"].forEach((tag) => {
      const components = element.getElementsByTagName(tag);
      for (let i = 0; i < components.length; i++) {
        components[i].textContent = "[ ... ]";
      }
    });
  });

  const serializer = new XMLSerializer();
  return serializer.serializeToString(truncatedKmlDoc);
}

export function stripNonPolygonalKMLFeatures(kml: string | Document) {
  const kmlDoc = typeof kml === "string" ? new DOMParser().parseFromString(kml, "text/xml") : kml;

  const nonPolygonalElements = [
    ...Array.from(kmlDoc.getElementsByTagName("Point")),
    ...Array.from(kmlDoc.getElementsByTagName("LineString")),
    ...Array.from(kmlDoc.getElementsByTagName("MultiPoint")),
    ...Array.from(kmlDoc.getElementsByTagName("MultiLineString")),
  ];
  nonPolygonalElements.forEach((element) => {
    // Find the Placemark parent
    let currentNode = element;
    while (currentNode && currentNode.tagName !== "Placemark") {
      currentNode = currentNode.parentNode as Element;
    }
    currentNode?.parentNode?.removeChild(currentNode);
  });

  const serializer = new XMLSerializer();
  return serializer.serializeToString(kmlDoc);
}
